var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCaie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_18045_3348)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_18045_3348)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18045_3348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9807 33.0603C39.17 31.7152 39.264 30.3584 39.2619 29C39.264 27.6416 39.17 26.2848 38.9807 24.9397H44.2986C45.2384 27.565 45.2384 30.435 44.2986 33.0603H38.9807ZM33.0017 41C31.8299 41 30.6336 39.7972 29.7163 37.7005C29.2972 36.7428 28.956 35.6511 28.7005 34.4661H37.303C37.0475 35.6506 36.7063 36.7423 36.2872 37.7005C35.3699 39.7972 34.1736 41 33.0017 41ZM28.4436 33.0603C28.0486 30.3678 28.0486 27.6322 28.4436 24.9397H37.5599C37.7596 26.2839 37.8587 27.6411 37.8561 29C37.8587 30.3589 37.7596 31.7161 37.5599 33.0603H28.4436ZM21.7049 33.0603C20.765 30.435 20.765 27.565 21.7049 24.9397H27.0228C26.6472 27.6335 26.6472 30.3665 27.0228 33.0603H21.7049ZM33.0017 17C34.1736 17 35.3699 18.2023 36.2872 20.2995C36.7063 21.2572 37.0475 22.3489 37.303 23.5339H28.7005C28.956 22.3494 29.2972 21.2577 29.7163 20.2995C30.6336 18.2023 31.8299 17 33.0017 17ZM43.6892 23.5334H38.7383C38.4571 22.1413 38.0661 20.8564 37.5758 19.7366C37.1788 18.8281 36.7288 18.0589 36.2361 17.4392C37.8336 17.8816 39.3214 18.652 40.6046 19.7013C41.8878 20.7505 42.9384 22.0557 43.6892 23.5334ZM29.7674 17.4387C29.2761 18.0589 28.8266 18.8277 28.4291 19.7356C27.9388 20.8564 27.5483 22.1413 27.2666 23.5325H22.3142C23.0653 22.0549 24.1159 20.7499 25.3991 19.7008C26.6823 18.6516 28.17 17.8812 29.7674 17.4387ZM22.3142 34.4666H27.2652C27.5464 35.8587 27.9374 37.1436 28.4277 38.2634C28.8252 39.1714 29.2747 39.9402 29.766 40.5603C28.1688 40.1178 26.6813 39.3474 25.3983 38.2982C24.1153 37.2491 23.065 35.9441 22.3142 34.4666ZM36.2361 40.5603C36.7274 39.9402 37.1774 39.1714 37.5744 38.2634C38.0647 37.1427 38.4552 35.8578 38.7369 34.4666H43.6892C42.9384 35.9444 41.8879 37.2496 40.6046 38.2989C39.3214 39.3483 37.8336 40.1188 36.2361 40.5613V40.5603Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_18045_3348",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_18045_3348"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18045_3348"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_18045_3348"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_18045_3348",
    result: "effect2_dropShadow_18045_3348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_18045_3348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18045_3348",
    x1: 5,
    y1: 1,
    x2: 61,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B35C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2913C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18045_3348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(21 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCaie);
export default __webpack_public_path__ + "static/media/ic_caie.35a9e858c54d980370841145768a6412.svg";
export { ForwardRef as ReactComponent };